import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import KYCIcon from 'public/images/kyc-icon.svg';
import LeftLineArrow from 'public/images/left-line-arrow.svg';
import useCurrentLocale from 'hooks/useCurrentLocale';
import BlofinNative from 'sdk';

interface KycAlertProps {
  isApp: boolean;
}

const KycAlert: FC<KycAlertProps> = ({ isApp }) => {
  const t = useTranslations('activity');
  const { localeLink } = useCurrentLocale();

  const handleClick = () => {
    if (isApp) {
      BlofinNative.goRouter({ category: 'goIdentityVerification', params: {} });
      return;
    }
    window.location.href = `${localeLink}/account/identification`;
  };

  return (
    <div
      data-is-app={isApp}
      onClick={handleClick}
      className={
        'sticky top-16 z-[1099] flex h-[36px] w-screen cursor-pointer select-none items-center gap-[10px] bg-[#FCDC9C] px-4 data-[is-app=true]:top-0 md:h-[48px] md:px-10'
      }
    >
      <KYCIcon className="hidden h-6 w-6 shrink-0 md:block" />
      <span className="text-sm font-normal leading-[18px] text-black md:text-md md:leading-6">
        {t('KYCNotification')}
      </span>
      <LeftLineArrow className="h-5 w-5 shrink-0 md:h-6 md:w-6" />
    </div>
  );
};

export default KycAlert;
